import {
    SET_LOADING, SET_VENDER_TYPES, SET_VENDER_TYPES_TOTAL,
} from "./mutations";
import ApiService from "@/core/services/ApiService";

export default {
  async fetchVenderTypes({ commit },  params = {}) {
    commit(SET_LOADING, true);
    ApiService.setHeader();
    return await ApiService.query("backend/vender_types",params)
        .then((result) => {
          result =result.data;
          commit(SET_VENDER_TYPES, result?.data ?? []);
          commit(SET_VENDER_TYPES_TOTAL, result?.total ?? []);
          commit(SET_LOADING, false);

          return result;
        })
        .catch(({response}) => {
          // console.log('error response', response);
        });
  },
};
